import { useRef, useState } from "react";
import "./style.scss";
import { useOutsideClick } from "../../../hooks/useOutsideClick";
import OliverText from "@builder/components/general/OliverText";
import { useTranslation } from "react-i18next";

interface UnitInputProps {
    title?: string;
    value: string;
    unit: string;
    noUnit?: boolean;
    min?: number;
    max?: number;
    mode?: "measure" | "currency";
    callback: (value: string, unit: string) => void;
}

const UnitInput: React.FC<UnitInputProps> = ({
    title,
    value,
    unit,
    noUnit,
    callback,
    min = 0,
    max = Number.MAX_SAFE_INTEGER,
    mode
}: UnitInputProps) => {
    const dropdownRef = useRef<HTMLInputElement>(null);
    const valueRef = useRef<HTMLInputElement>(null);
    const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
    const { t } = useTranslation();
    const [u, setU] = useState<string>(unit);

    const handleChange = () => {
        const value = valueRef.current?.value;
        if (value && u) {
            const valueNum = parseInt(value);

            if (typeof valueNum === "number" && !Number.isNaN(valueNum)) {
                if (valueNum <= min) {
                    callback(min.toString(), u);
                } else if (valueNum >= max) {
                    callback(max.toString(), u);
                } else {
                    callback(valueNum.toString(), u);
                }
            }
        } else if (value === "" && u) {
            callback("", u);
        }
    };

    const handleUnitChange = (unit: string) => {
        setDropdownOpen(false);
        if (u !== unit) {
            setU(unit);
            const value = valueRef.current?.value;
            if (value) callback(value, unit);
        }
    };

    const openDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    useOutsideClick(dropdownRef, () => {
        setDropdownOpen(false);
    });

    // useEffect(() => {
    //     if (unit !== u) {
    //         setU(unit);
    //     }
    // }, [unit]);

    return (
        <div className={["unit-input-wrapper", dropdownOpen && "dropdown-open"].filter(Boolean).join(" ")}>
            {title && <OliverText text={t("generalComponents.unitInput." + title)} size="xs" />}
            <div className={["unit-input", title && "titled"].filter(Boolean).join(" ")}>
                <input type="text" className="value-input" value={value} ref={valueRef} onInput={handleChange} />
                <div className="unit-wrapper" ref={dropdownRef}>
                    <input type="text" value={u} readOnly onClick={openDropdown} />
                    {!noUnit && (
                        <div className="unit-options">
                            {mode === "currency" ? (
                                <>
                                    <div className="unit-option" onClick={() => handleUnitChange("$")}>
                                        <OliverText text="$" size="xxs" />
                                    </div>
                                    <div className="unit-option" onClick={() => handleUnitChange("%")}>
                                        <OliverText text="%" size="xxs" />
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="unit-option" onClick={() => handleUnitChange("px")}>
                                        <OliverText text="px" size="xxs" />
                                    </div>
                                    <div className="unit-option" onClick={() => handleUnitChange("%")}>
                                        <OliverText text="%" size="xxs" />
                                    </div>
                                </>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default UnitInput;
